<template>
  <div
    class="audio-player d-flex align-items-center justify-content-between p-3"
  >
    <span class="pointer" @click="togglePlayPause">
      <img
        v-show="!isPlaying"
        src="@/assets/img/courses/playaudio.svg"
        alt="Play"
      />
      <img
        v-show="isPlaying"
        src="@/assets/img/courses/pauseaudio.svg"
        alt="Play"
      />
    </span>
    <div
      class="wid-70"
      :class="{ 'd-flex align-items-center justify-content-center': !isLoaded }"
    >
      <!-- !important : display flex should be used only when the waveform is not loaded -->
      <Loader v-if="!isLoaded" />
      <div ref="waveform"></div>
    </div>
    <div class="duration-font">
      <div class="time-width">{{ formatTime(currentTime) }}</div>
      /
      <div class="time-width">{{ formatTime(duration) }}</div>
    </div>
  </div>
</template>

<script>
import WaveSurfer from "wavesurfer.js";
import Loader from "@/components/fixedComponents/Loader.vue";

export default {
  name: "AudioPlayer",
  props: {
    src: {
      type: String,
      required: true,
    },
  },
  components: { Loader },
  data() {
    return {
      wavesurfer: null,
      isPlaying: false,
      currentTime: 0,
      duration: 0,
      isLoaded: false,
    };
  },
  mounted() {
    this.setMetaData();
  },
  beforeDestroy() {
    if (this.wavesurfer) {
      this.wavesurfer.destroy();
    }
  },
  watch: {
    src() {
      this.setMetaData();
    },
  },
  methods: {
    setMetaData() {
      if (this.wavesurfer) {
        this.isLoaded = false;
        this.wavesurfer.stop();
        this.wavesurfer.destroy();
        this.isPlaying = false;
        this.currentTime = 0;
        this.duration = 0;
      }

      this.wavesurfer = WaveSurfer.create({
        container: this.$refs.waveform,
        waveColor: "#FFFFFF",
        progressColor: "#FFFFFF66",
        height: 35,
        cursorWidth: 1,
        // Below options are commented out as they are not used in the current implementation. Use these options if you want to customize the waveform further
        // barWidth: 2,
        // barRadius: 20,
        // barGap: 4,
        cursorColor: "#FFB750",
        normalize: true,
        backend: "WebAudio",
      });
      this.wavesurfer.load(this.src);
      this.wavesurfer.on("ready", () => {
        this.duration = this.wavesurfer.getDuration();
        this.isLoaded = true;
      });

      this.wavesurfer.on("audioprocess", () => {
        this.currentTime = this.wavesurfer.getCurrentTime();
      });

      this.wavesurfer.on("finish", () => {
        this.isPlaying = false;
      });
    },
    togglePlayPause() {
      if (!this.isLoaded) return;
      this.wavesurfer.playPause();
      this.isPlaying = this.wavesurfer.isPlaying();
    },
    formatTime(seconds) {
      const minutes = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${minutes.toString().padStart(2, "0")}:${secs
        .toString()
        .padStart(2, "0")}`;
    },
  },
};
</script>

  <style scoped>
.audio-player {
  width: 100%;
  height: 60px;
  background-color: #20639b;
  border-radius: 18px;
}
.duration-font {
  font-family: "Montserrat", sans-serif;
  color: #ffffff;
  font-weight: 600;
  font-size: 16px;
  line-height: 28px;
  display: flex;
  align-items: center;
  gap: 3px;
}
.time-width {
  width: 45px;
}
.wid-70 {
  flex: 1;
}

@media screen and (max-width: 768px) {
  .duration-font {
    font-size: 13px;
  }
  .time-width {
    width: 40px;
  }
}
</style>
